import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import css from './Defenders.module.css';
import {saveDefenders, setShowDefenders} from "../../../store/defenderSlice";
import MyGyms from "./MyGyms/MyGyms";
import axios from "../../../axios-pogo";
import SearchGyms from "./SearchGyms/SearchGyms";

const Defenders = (props) => {
	const [gyms, setGyms] = useState(null);
	useEffect(() => {
		axios.get("/mod/pokemon/map/ajax/get-gyms.php").then(result => {
			setGyms(result.data);
		});
	}, [])

	const addDefender = gymId => {
		props.saveDefenders([...props.defenders, gymId]);
	};

	const removeDefender = delGymId => {
		props.saveDefenders([...props.defenders].filter(id => id !== delGymId));
	};

	const clearDefenders = () => {
		props.saveDefenders([]);
	};

	let content = <div>Loading...</div>;

	if( gyms )
		content = <>
			<SearchGyms gyms={gyms} add={addDefender}/>
			{props.defenders.length ?
				<MyGyms
					defenders={gyms.filter(gym => props.defenders.includes(gym.id))} gyms={gyms}
					removeDefender={removeDefender}
					clearDefenders={clearDefenders}
				/>
			: null}
		</>;

	return (<Dialog
		className={css.Settings}
		open={props.showDefenders}
		maxWidth='md'
		fullWidth={true}
	>
		<DialogTitle id="alert-dialog-title">Defenders</DialogTitle>
		<DialogContent>
			{content}
		</DialogContent>
		<DialogActions>
			<Button onClick={() => props.setShowDefenders(false)} color="primary" autoFocus>
				Close
			</Button>
		</DialogActions>

	</Dialog>);
};

const mapStateToProps = (state) => {
	return {
		showDefenders: state.defenders.showDefenders,
		defenders: state.defenders.defenders,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowDefenders: (val) => dispatch(setShowDefenders(val)),
		saveDefenders: (gymIds) => dispatch(saveDefenders(gymIds)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Defenders);